import {
  useGetValidationTasksApiV1ModelValidationTasksGet,
  useValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatch,
} from "../../../../vl-api/vlComponents";
import { App } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { invalidateActiveQueryByOperationId } from "../../../../vl-api/vlUtils";
import last from "lodash/last";
import { ValidationTaskResponse } from "../../../../vl-api/vlSchemas";
import { isActiveTask } from "./modelJobsUtils";

const POLLING_INTERVAL_MS = 2000;

export const useValidationTasks = (datasetId: string) => {
  const { notification, modal } = App.useApp();
  const queryClient = useQueryClient();

  const { data, isLoading, isError } =
    useGetValidationTasksApiV1ModelValidationTasksGet<{
      tasks: ValidationTaskResponse[];
    }>(
      {
        queryParams: { dataset_id: datasetId },
      },
      {
        refetchInterval: ({ state }) => {
          if (isActiveTask(last(state.data?.tasks))) {
            return POLLING_INTERVAL_MS;
          }
        },
      },
    );

  const validationActionsMutation =
    useValidationTaskActionsEndpointApiV1ModelValidationTasksTaskIdPatch({
      onSuccess: () => {
        notification.success({ message: "Validation aborted" });
        invalidateActiveQueryByOperationId(
          queryClient,
          "getValidationTasksApiV1ModelValidationTasksGet",
        );
      },
    });

  const handleCancelTaskClick = (taskId: string) => {
    modal.confirm({
      title: "Abort validation?",
      content: "The validation job will stop and can't be resumed.",
      okText: "Yes",
      okButtonProps: { danger: true },
      onOk: () =>
        validationActionsMutation.mutate({
          pathParams: { taskId },
          queryParams: { action: "CANCEL" },
        }),
      cancelText: "No",
    });
  };

  return {
    handleCancelTaskClick,
    task: last<ValidationTaskResponse>(data?.tasks),
    tasks: (data?.tasks ?? []) as ValidationTaskResponse[],
    isLoading,
    isError,
  };
};
